import { Navigate, Outlet } from "react-router-dom";
import { isEmpty } from "../Utils/helpers";

const PublicRoute = () => {
  return isEmpty(localStorage.getItem("token")) ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

export default PublicRoute;
